import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { useChatContext } from '../../../providers/ChatProvider';

const SuggestedQuestions = () => {
  const { suggestedQuestions, sendMessage, isLoading } = useChatContext();

  const handleQuestionClick = (question) => {
    if (!isLoading) {
      sendMessage(question);
    }
  };

  if (!suggestedQuestions.length) return null;

  return (
    <div className="suggested-questions">
      <h6>
        <FontAwesomeIcon icon={faLightbulb} className="me-2" />
        Preguntas sugeridas:
      </h6>
      <div className="d-grid gap-2">
        {suggestedQuestions.map((question, index) => (
          <Button
            key={index}
            variant="outline-primary"
            size="sm"
            className="suggested-question"
            onClick={() => handleQuestionClick(question)}
            disabled={isLoading}
          >
            {question}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedQuestions; 